/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoSwitchWorkspaceInput = {
    clientMutationId?: string | null;
    workspaceSlug: string;
};
export type SwitchWorkspaceDialogMutationVariables = {
    input: infoSwitchWorkspaceInput;
};
export type SwitchWorkspaceDialogMutationResponse = {
    readonly infoSwitchWorkspace: {
        readonly clientMutationId: string | null;
    } | null;
};
export type SwitchWorkspaceDialogMutation = {
    readonly response: SwitchWorkspaceDialogMutationResponse;
    readonly variables: SwitchWorkspaceDialogMutationVariables;
};



/*
mutation SwitchWorkspaceDialogMutation(
  $input: infoSwitchWorkspaceInput!
) {
  infoSwitchWorkspace(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoSwitchWorkspacePayload",
    "kind": "LinkedField",
    "name": "infoSwitchWorkspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SwitchWorkspaceDialogMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SwitchWorkspaceDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9e771ff35b16866cd91b63d265818fd6",
    "id": null,
    "metadata": {},
    "name": "SwitchWorkspaceDialogMutation",
    "operationKind": "mutation",
    "text": "mutation SwitchWorkspaceDialogMutation(\n  $input: infoSwitchWorkspaceInput!\n) {\n  infoSwitchWorkspace(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '1e36417bef41c4f2682624681e0af87b';
export default node;
